import { MutableRefObject, useRef } from 'react';
import lineClamp from '@tools/lineClamp';
import { SerializedStyles } from '@emotion/react';

const useSafariLineClamp = (numLines: number): { ref: MutableRefObject<HTMLDivElement>; clamp: SerializedStyles } => {
  const ref = useRef(null);
  const tempTag = (...[, measurement, unit]): string => {
    return `${measurement}${unit}`;
  };

  const calculateHeight = (currentRef: HTMLDivElement): string => {
    if (typeof window !== 'undefined' && currentRef) {
      const children = currentRef.querySelectorAll('h3, h4, p, li');
      if (children?.length > 0) {
        let totalHeight = 0;
        let numLinesLeft = numLines;
        let lineHeightUnit: string;
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          // Actual height of child
          const childHeight = child.clientHeight;
          // Line height given with both measurement and unit - i.e. '20px'
          const { lineHeight } = getComputedStyle(child);
          // Splits out the measurement and unit for math purposes
          const lineHeightMeasurement = parseInt(lineHeight.match(/\d+/)[0], 10);
          lineHeightUnit = lineHeight.match(/[a-zA-Z]+/g)[0];

          // If the current element height is greater than the number of lines left use clamp the height and break out
          // Else add the height of the current element + the margin of that element and subtract
          // the number of lines in the current child from the number of lines left
          if (childHeight >= lineHeightMeasurement * numLinesLeft) {
            totalHeight += lineHeightMeasurement * numLinesLeft;
            break;
          } else {
            const childMarginHeight = parseInt(getComputedStyle(child).marginBlockEnd.match(/\d+/)[0], 10);
            numLinesLeft -= childHeight / lineHeightMeasurement;
            totalHeight = totalHeight + childHeight + childMarginHeight;
          }
        }
        return tempTag`${totalHeight}${lineHeightUnit}`;
      }
    }
  };
  const safariHeight = calculateHeight(ref.current);

  const clamp = lineClamp(numLines, safariHeight);

  return { ref, clamp };
};

export default useSafariLineClamp;
